import { defineStore } from "pinia"

export const useLoadingStore = defineStore({
  id: "loading-store",
  state: () => ({
    loadingStatus: false,
    isVideoVisible: false,
    videoPlayer: null as HTMLVideoElement | null,
  }),
  actions: {
    changeLoadingStatus(status: boolean) {
      this.loadingStatus = status;
    },
    setVideoPlayer(ref: HTMLVideoElement | null) {
      this.videoPlayer = ref;
    },
    showVideo() {
      this.isVideoVisible = true;
      if (this.videoPlayer) {
        this.videoPlayer.muted = false; // Ses açılır
        this.videoPlayer.play(); // Video oynatılır
      }
    },
    closeVideo() {
      this.isVideoVisible = false;
      if (this.videoPlayer) {
        this.videoPlayer.pause(); // Video durdurulur
      }
    },
  },
});
